/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyertagline2Inputs */

const en_checkinflyertagline2 = /** @type {(inputs: Checkinflyertagline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan, add your name, done. See who's here and say hi – even to people you don't know yet.`)
};

const de_checkinflyertagline2 = /** @type {(inputs: Checkinflyertagline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scannen, Namen rein, fertig. Sieh, wer da ist, und sag Hi – auch zu denen, die du noch nicht kennst.`)
};

/**
* | output |
* | --- |
* | "Scan, add your name, done. See who's here and say hi – even to people you don't know yet." |
*
* @param {Checkinflyertagline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyertagline2 = /** @type {((inputs?: Checkinflyertagline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyertagline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyertagline2(inputs)
	return de_checkinflyertagline2(inputs)
});
export { checkinflyertagline2 as "checkinFlyerTagline" }